import React from 'react'
import { Select } from '@mantine/core'
import { formatInTimeZone } from 'date-fns-tz'

import { TIMEZONES } from '@/utils/timezones'

export const formatTimezoneOption = (
  timezone: string,
  referenceDate: Date,
): string => {
  try {
    return `${timezone} (GMT${formatInTimeZone(referenceDate, timezone, 'xxx')})`
  } catch {
    return timezone
  }
}

export const TimezoneSelect: React.FC<
  {
    value?: string | null
    onChange: (value: string | null) => void
    referenceDate?: Date
  } & Omit<React.ComponentProps<typeof Select>, 'value' | 'data' | 'onChange'>
> = ({ value, onChange, referenceDate = new Date(), ...props }) => {
  // a zone from outside this list needs an option, or the field renders blank
  const timezones =
    value && !TIMEZONES.includes(value) ? [...TIMEZONES, value] : TIMEZONES

  return (
    <Select
      {...props}
      data={timezones.map(timezone => ({
        value: timezone,
        label: formatTimezoneOption(timezone, referenceDate),
      }))}
      value={value}
      onChange={onChange}
      searchable
    />
  )
}
